import type { Movimentacao, StatusMovimentacao } from '../../../models';
import { STATUS_MOVIMENTACAO_LABELS } from '../solicitacaoDetailsPage.definitions';

/** 'aguardando_retirada_correios' só entra na lista quando o método de entrega é
 * Correios (ver getOpcoesStatus abaixo) — não faz sentido pros demais métodos. */
const STATUS_MOVIMENTACAO_OPCOES_BASE: StatusMovimentacao[] = [
  'aguardando_preparacao',
  'aguardando_postagem_retirada',
  'em_transito',
  'entregue',
  'cancelada',
];

function getOpcoesStatus(movimentacao: Movimentacao): StatusMovimentacao[] {
  if (movimentacao.metodoEntrega !== 'correios') return STATUS_MOVIMENTACAO_OPCOES_BASE;
  return [
    'aguardando_preparacao',
    'aguardando_postagem_retirada',
    'em_transito',
    'aguardando_retirada_correios',
    'entregue',
    'cancelada',
  ];
}

interface StatusMovimentacaoCampoProps {
  movimentacao: Movimentacao;
  podeEditar: boolean;
  onChange: (status: StatusMovimentacao) => void;
}

/** Status da Movimentação no rodapé do card (select pro SI, texto pros demais). */
export default function StatusMovimentacaoCampo({ movimentacao, podeEditar, onChange }: StatusMovimentacaoCampoProps) {
  return (
    <div className="mt-3 border-t border-gray-100 pt-3">
      <p className="text-xs font-medium uppercase text-gray-400">Status</p>
      {podeEditar ? (
        <select
          className="input-primary mt-1 w-full"
          value={movimentacao.statusMovimentacao}
          onChange={(event) => onChange(event.target.value as StatusMovimentacao)}
        >
          {getOpcoesStatus(movimentacao).map((status) => (
            <option key={status} value={status}>
              {STATUS_MOVIMENTACAO_LABELS[status]}
            </option>
          ))}
        </select>
      ) : (
        <p className="mt-1 text-sm text-gray-600">{STATUS_MOVIMENTACAO_LABELS[movimentacao.statusMovimentacao]}</p>
      )}
    </div>
  );
}
